import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './help-search.component.html',
  styleUrls: ['./help-search.component.scss'],
})
export class HelpSearchComponent implements OnInit {
  ngOnInit(): void {}
}
